import { fr, es, pt, ar, zhCN, enUS } from "date-fns/locale";

// The date-fns locale of a site language; English (US) for anything else.
const LOCALES = { fr, es, pt, ar, zh: zhCN, en: enUS };
export const dateFnsLocale = (code) => LOCALES[code] || enUS;
